import React, { FC } from 'react';
import classNames from 'classnames';

import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { StatusAdornment, StatusAdornmentProps } from 'Src/feature/status/StatusAdornment';

import styles from './ProvisionItemCta.module.scss';

const sectionId = 'ProvisionItemCta';

interface ProvisionItemCtaProps {
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  title?: string;
  subTitle?: string;
  indicator?: {
    color: StatusAdornmentProps['color'];
    message?: string
  }
}

const ProvisionItemCta: FC<ProvisionItemCtaProps> = ({
  className,
  selected,
  disabled,
  onClick,
  title,
  subTitle,
  indicator,
  ...rest
}) => (
  <CTA
    {...rest}
    className={classNames(styles.root, className)}
    selected={selected}
    disabled={disabled}
    onClick={onClick}
  >
    <Flex gap="sm" alignItems="flex-start" fullWidth>
      <Copy variant="body" weight="bold">{title}</Copy>
      <Copy variant="body" weight="bold">{subTitle}</Copy>
    </Flex>

    {
      indicator !== undefined && (
        <Flex gap="sm" horizontal>
          <Copy data-testid="indicator-message" variant="body" weight="bold" value={indicator.message}/>
          <StatusAdornment color={indicator.color} size="lg" />
        </Flex>
      )
    }
  </CTA>
);

export type { ProvisionItemCtaProps };
export { ProvisionItemCta, sectionId };
